<template>
  <v-container class="signup-container">
    <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
      <v-row justify="center">
        <v-col class="d-flex flex-column" cols="12" sm="6">
          <div
            class="text-h5 font-weight-bold primary--text"
            style="margin-bottom:1rem;"
          >
            {{ $t('password.title') }}
          </div>
          <span class="text-subtitle-2 font-weight-bold">{{
            $t('password.email')
          }}</span>
          <v-text-field
            :placeholder="$t('password.emailPlaceholder')"
            type="email"
            v-model.trim="email"
            label="E-mail"
            :error-messages="error"
            :rules="[rules.required]"
            clearable
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-btn
            class="font-weight-bold"
            tile
            fixed
            x-large
            style="width:50%;z-index: 5;left: 0;bottom: 0px;height: 56px;"
            to="signin"
          >
            {{ $t('back') }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            class="font-weight-bold bottom-disable-p"
            color="primary"
            tile
            fixed
            x-large
            style="width: 50%;z-index: 5;left: 50%;bottom: 0px;height: 56px;"
            @click="onSubmit()"
            :disabled="email.length < 1"
          >
            {{ $t('password.request') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: '',
    rules: {
      required: (value) => !!value || ''
    },
    error: ''
  }),
  created() {
    this.rules = {
      required: (value) => !!value || this.$t('requiredMessage')
    }
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        const params = {
          email: this.email
        }
        this.$store.dispatch('SEND_VERIFY_CODE', params).then((res) => {
          if (res.data.status) {
            this.$router.push({
              name: 'passwordVerify',
              params: { email: params.email }
            })
          }

          if (res.data.code === 'invalid') {
            this.error = this.$t('password.invalidMessage')
          } else if (res.code === 'token') {
            this.error = this.$t('password.tokenMessage')
          } else {
            this.error = res.code
          }
        })
      }
    }
  }
}
</script>

<style>
.desc-box {
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  margin: 1rem 0;
}
</style>
